import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "dashed-line"
}
const _hoisted_2 = { class: "item" }
const _hoisted_3 = {
  key: 1,
  class: "dashed-line"
}
const _hoisted_4 = { class: "item" }

import i18n from "@/plugins/vue-i18n";
import { VButtonDropdown } from "@/components";
import { VInputCheckbox } from "@/components";
import { VIconSvg } from "@/components";
import { VInputCheckboxMultiState } from "@/components";
import { VLink } from "@/components";
import { isEqual } from "lodash";
import debounce from "lodash/debounce";
import {
  computed,
  reactive,
  ref,
  watch,
} from "vue";
import { kebabCase } from "lodash";
import { getRandomId } from "@/mixins/global.mixin";

export interface Props {
  text?: string;
  value?: {
    active: [];
    disabled: [];
  };
  iconName?: string;
  variant?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VColumnControl',
  props: {
    text: { default: "" },
    value: { default: () => ({
    active: [],
    disabled: [],
  }) },
    iconName: { default: "" },
    variant: { default: "select" }
  },
  emits: ["input", "resetColumn"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const emit = __emit;

const props = __props;

const key = ref(getRandomId());
let items = reactive({
  active: [],
  disabled: [],
});

const initialListActiveItems = ref([]);
const columnControlDropdown = ref(null);

const batchActionValue = computed({
  get() {
    const { active, disabled } = items;

    const activeItems = active.filter(({ alwaysEnabled }) => !alwaysEnabled);
    let value = "selectedNone";

    if (activeItems.length) {
      value = disabled.length ? "selectedPartly" : "selectedAll";
    }

    return value;
  },

  set(value) {
    switch (value) {
      case "selectedAll":
        selectAll();
        break;
      case "selectedNone":
        deselectAll();
        break;
    }
  },
});

const batchActionOptions = computed(() => {
  const options = [
    {
      code: "selectedNone",
      label: i18n.t("label.selectAll"),
    },
    {
      code: "selectedPartly",
      label: i18n.t("label.selectAll"),
      icon: {
        name: "Dash",
        colorTag: "fill",
      },
    },
    {
      code: "selectedAll",
      label: i18n.t("label.deselectAll"),
      icon: {
        name: "Check",
        colorTag: "stroke",
      },
    },
  ];

  return options.filter((item) => {
    let value = true;

    if (item.code === "selectedPartly") {
      value = batchActionValue.value === "selectedPartly";
    }

    return value;
  });
});

const columnControlClasses = computed(() => {
  return props.variant === "icon" ? "icon-column-control" : "";
});

const textValue = computed(() => {
  let text = props.text ? props.text : i18n.t("button.columns");

  if (["icon", "button-icon"].includes(props.variant)) {
    text = "";
  }

  return text;
});

watch(
  () => props.value,
  (value) => {
    items.active = value.active;
    items.disabled = value.disabled;

    if (!initialListActiveItems.value.length) {
      initialListActiveItems.value = [...items.active];
    }
  },
  { immediate: true, deep: true }
);

watch(
  () => items,
  (value) => {
    if (!isEqual(value, props.value)) {
      emit("input", value);
    }
  },
  { deep: true }
);

const onHideDropdown = debounce(() => {
  key.value = getRandomId();
}, 75);

const onInputActiveColumn = (index: number) => {
  items.disabled.unshift(items.active[index]);

  items.active.splice(index, 1);
};

const onInputDisabledColumn = (index: number) => {
  items.active.push(items.disabled[index]);

  items.disabled.splice(index, 1);
};

const selectAll = () => {
  const { active, disabled } = items;

  items.active = [...active, ...disabled];
  items.disabled = [];
};

const deselectAll = () => {
  const { active, disabled } = items;

  const activeAlwaysEnabled = active.filter(({ alwaysEnabled }) => alwaysEnabled);
  const activeNotAlwaysEnabled = active.filter(({ alwaysEnabled }) => !alwaysEnabled);

  items.active = activeAlwaysEnabled;
  items.disabled = [...activeNotAlwaysEnabled, ...disabled];
};

const checkMove = ({ to, draggedContext }) => {
  const { type } = to.__draggable_component__.$attrs;
  const { alwaysEnabled } = draggedContext?.element;

  let allowMove = true;

  if (alwaysEnabled && type === "disabled") {
    allowMove = false;
  }

  return allowMove;
};

const resetColumns = () => {
  items.active = [...initialListActiveItems.value];
  items.disabled = [];

  emit("resetColumn");
};

const hideColumnControl = () => {
  const { isShownItems, hide } = columnControlDropdown.value;

  if (isShownItems) hide();
};

__expose({
  hideColumnControl,
});

return (_ctx: any,_cache: any) => {
  const _component_Draggable = _resolveComponent("Draggable")!

  return (_openBlock(), _createBlock(_unref(VButtonDropdown), {
    key: key.value,
    ref_key: "columnControlDropdown",
    ref: columnControlDropdown,
    text: textValue.value,
    "icon-name": props.iconName,
    variant: props.variant,
    "list-x-position": "right",
    class: _normalizeClass(["column-control", columnControlClasses.value]),
    onHide: _unref(onHideDropdown)
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(VInputCheckboxMultiState), {
        modelValue: batchActionValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((batchActionValue).value = $event)),
        options: batchActionOptions.value,
        "track-by": "code",
        class: "toggle-all"
      }, null, 8, ["modelValue", "options"]),
      (_unref(items).active.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1))
        : _createCommentVNode("", true),
      _createVNode(_component_Draggable, {
        modelValue: _unref(items).active,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(items).active) = $event)),
        move: checkMove,
        handle: ".icon-drag-and-drop",
        class: "items",
        group: "columns",
        type: "enabled",
        "item-key": "key"
      }, {
        item: _withCtx(({ element, index }) => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_unref(VIconSvg), {
              name: "DragAndDrop",
              class: "icon-drag-and-drop",
              color: "fc-stroke",
              "color-tag": "fill",
              size: "xs"
            }),
            _createVNode(_unref(VInputCheckbox), {
              value: true,
              label: element.title,
              disabled: element.alwaysEnabled,
              "data-cy": `column-control-active-${_unref(kebabCase)(element.key)}`,
              onInput: ($event: any) => (onInputActiveColumn(index))
            }, null, 8, ["label", "disabled", "data-cy", "onInput"])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      (_unref(items).disabled.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3))
        : _createCommentVNode("", true),
      _createVNode(_component_Draggable, {
        modelValue: _unref(items).disabled,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(items).disabled) = $event)),
        class: "items",
        group: "columns",
        type: "disabled",
        "item-key": "key"
      }, {
        item: _withCtx(({ element, index }) => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(VIconSvg), {
              name: "DragAndDrop",
              color: "fc-stroke",
              "color-tag": "fill",
              size: "xs"
            }),
            _createVNode(_unref(VInputCheckbox), {
              value: false,
              "data-cy": `column-control-disabled-${_unref(kebabCase)(element.key)}`,
              label: element.title,
              onInput: ($event: any) => (onInputDisabledColumn(index))
            }, null, 8, ["data-cy", "label", "onInput"])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_unref(VLink), {
        "data-cy": "reset-column-control",
        text: _ctx.$t('label.reset'),
        class: "reset",
        onClick: resetColumns
      }, null, 8, ["text"])
    ], undefined, true),
    _: 1
  }, 8, ["text", "icon-name", "variant", "class", "onHide"]))
}
}

})